/**
 * Lookup de empresas da holding para exibir a "dona" de cada vaga.
 *
 * Reaproveita ECOSYSTEM (6 frentes) e adiciona a própria Holding ("guebly"),
 * usada como padrão para vagas corporativas/transversais. Cada vaga no banco
 * tem a coluna `empresa` (slug); `getCompany(slug)` devolve nome, logo e cor
 * da marca para o badge no card e o banner na página da vaga.
 */
import { ECOSYSTEM } from "./ecosystem";

/* Marca/frente padrão de vagas transversais (empresa = "guebly").
   A operação roda dentro da Guebly LTDA (ver getEmployer). Sem logo quadrado
   próprio, usa o chip de iniciais colorido. */
export const HOLDING = {
  slug: "guebly",
  name: "Guebly",
  initials: "G",
  logo: "/assets/companies/guebly.png", // logo oficial (G roxo) — fundo branco no tile
  color: "#7C3AED",
  segment: "Vaga transversal do grupo",
};

const MAP = Object.fromEntries(ECOSYSTEM.map((c) => [c.slug, c]));
MAP.guebly = HOLDING;

/** Retorna os dados da marca/frente da vaga (cai em Guebly se desconhecida). */
export function getCompany(slug) {
  return MAP[slug] || HOLDING;
}

/**
 * Entidade jurídica CONTRATANTE da vaga.
 *
 * Importante: a Guebly Holding LTDA apenas administra/governa o grupo — ela
 * NÃO contrata. Quem assina a contratação é a Guebly LTDA (operadora onde
 * rodam a maioria das frentes) ou a Guebly Contábil LTDA (entidade própria).
 */
export const EMPLOYERS = {
  contabil: { razao: "Guebly Contábil LTDA", cnpj: "66.801.020/0001-70" },
  default:  { razao: "Guebly LTDA",          cnpj: "63.316.501/0001-00" },
};

/* Holding administradora do grupo (governança — não contrata). */
export const HOLDING_ENTITY = { razao: "Guebly Holding LTDA", cnpj: "64.938.092/0001-38" };

/** Retorna a entidade contratante da vaga a partir da marca/frente (empresa). */
export function getEmployer(empresa) {
  return EMPLOYERS[empresa] || EMPLOYERS.default;
}
